const COLORS = ['#5865f2', '#57f287', '#fee75c', '#ed4245', '#eb459e'];

const hashCode = (str) => {
    let hash = 0;
    if (!str) return hash;
    for (let i = 0; i < str.length; i++) { hash = str.charCodeAt(i) + ((hash << 5) - hash); }
    return hash;
};

export const getAvatarColor    = (userId) => COLORS[Math.abs(hashCode(userId)) % COLORS.length];
export const getAvatarColorByName = (name) => COLORS[Math.abs(hashCode(name))   % COLORS.length];
